import { render, staticRenderFns } from "./CardMain.vue?vue&type=template&id=59c6062a&"
import script from "./CardMain.vue?vue&type=script&lang=js&"
export * from "./CardMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports